<template>
  <CRow>
    <CCol col="12" xl="12">
      <CCard>
        <PageTitle title="Users" :rows="rows" />
        <CCardBody>
          <SubNav :csv_export="csv_export" />
          <div class="overflow-auto">
            <b-table
              id="my-table"
              :items="items"
              :fields="fields"
              :per-page="perPage"
              :current-page="currentPage"
              small
            >
              <!-- A custom formatted column -->

              <template #cell(countryNameCode)="data">
                <CIcon
                  :name="'cif-' + data.item.countryNameCode.toLowerCase()"
                  width="40"
                />
              </template>
              <template #cell(onboard)="data">
                <div class="stripe-details-box">
                  <CInputCheckbox
                    :checked="data.item.onboard"
                    class="center"
                    @update:checked="(e) => check(data.item, e)"
                    custom
                  />
                </div>
              </template>
              <template #cell(commission)="data">
                <CInput
                  type="number"
                  min="0"
                  max="100"
                  id="commission"
                  :value="data.item.commission"
                  @change="(e) => changeCommission(data.item, e)"
                  placeholder="commission"
                />
              </template>
              <template #cell(deleteID)="data">
                <CButton
                  v-if="data.item.onboard"
                  color="success"
                  @click="
                    (e) => deleteAccount(data.item.deleteID, data.item.uid)
                  "
                  >Delete</CButton
                >
              </template>
            </b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"
              style="float: right"
            ></b-pagination>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import firebase from "firebase";
import axios from "axios";
import {
  timeConverter,
  from_0,
  to_24,
  getDateLabel,
} from "../../common-functions.js";

import * as Const from "../../const.js";
import PageTitle from "../component/PageTitle.vue";
import SubNav from "../component/SubNav.vue";
export default {
  name: "Users",
  components: { PageTitle, SubNav },
  data() {
    return {
      currentPage: 1,
      perPage: Const.perPage,
      items: [],
      fields: [
        {
          key: "phoneNumber",
          label: "Phone Number",
          _classes: "font-weight-bold",
          sortable: true,
        },
        { key: "countryNameCode", label: "Country", sortable: true },
        { key: "lang", label: "Language", sortable: true },
        { key: "currencyCode", label: "Currency", sortable: true },
        { key: "amountSumGave", label: "Sum of Gave", sortable: true },
        { key: "amountSumGot", label: "Sum of Got", sortable: true },
        { key: "cashSumGave", label: "Cash Gave", sortable: true },
        { key: "cashSumGot", label: "Cash Got", sortable: true },
        { key: "businessCount", label: "Count of Business", sortable: true },
        { key: "createdAt", label: "Created At", sortable: true },
        { key: "uid", label: "ID", sortable: true },
        {
          key: "onboard",
          label: "Stripe Onboard",
          _style: { width: "1%" },
          sorter: false,
          filter: false,
        },
        {
          key: "commission",
          label: "Commission(%)",
          _style: { width: "1%" },
          sorter: false,
          filter: false,
        },
        {
          key: "deleteID",
          label: "Action",
        },
      ],
      activePage: 1,
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
    need_refresh() {
      return (
        this.$store.state.selcountryCode +
        (this.$store.state.showSubNav.user
          ? "-" + this.$store.state.seluid
          : "") +
        (this.$store.state.showSubNav.business
          ? "-" + this.$store.state.selbid
          : "") +
        (this.$store.state.showSubNav.customer
          ? "-" + this.$store.state.selcid
          : "") +
        (this.$store.state.showSubNav.date
          ? "-" + getDateLabel(this.$store.state.from, this.$store.state.to)
          : "")
      );
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
    need_refresh: {
      immediate: true,
      handler(value) {
        this.load("data");
      },
    },
  },
  created() {
    this.$store.commit("set", [
      "showSubNav",
      { user: false, business: false, customer: false, date: true },
    ]);
  },
  methods: {
    load(type) {
      const db = firebase.firestore();
      if (type == "data") {
        //user who is not admin.
        var ds = db.collection("users").where("role", "==", "");
        this.$store.commit("set", ["loading_data", true]);
        if (this.$store.state.selcountryCode != "")
          ds = ds.where(
            "countryNameCode",
            "==",
            this.$store.state.selcountryCode
          );
        if (this.$store.state.from != "")
          ds = ds.where("createdAt", ">=", from_0(this.$store.state.from));
        if (this.$store.state.to != "")
          ds = ds.where("createdAt", "<=", to_24(this.$store.state.to));
        ds = ds.orderBy("createdAt", "desc");
        try {
          ds.get().then((querySnapshot) => {
            this.items = [];
            this.page = 0;

            querySnapshot.forEach((doc) => {
              this.items.push({
                phoneNumber: doc.data().phoneNumber,
                countryNameCode: doc.data().countryNameCode,
                lang: doc.data().lang,
                currencyCode: doc.data().currencyCode,
                amountSumGave: doc.data().amountSumGave,
                amountSumGot: doc.data().amountSumGot,
                cashSumGave: doc.data().cashSumGave,
                cashSumGot: doc.data().cashSumGot,
                businessCount: doc.data().businessCount,
                createdAt: timeConverter(doc.data().createdAt.seconds),
                commission: doc.data().commission,
                onboard: doc.data().onboard,
                uid: doc.id,
                deleteID: doc.data().account_id,
              });
            });
            this.$store.commit("set", ["loading_data", false]);
          });
        } catch (e) {
          console.log(e);
          this.$store.commit("set", ["loading_data", false]);
        } finally {
        }
      }
    },
    check(item, e) {
      var db = firebase.firestore();
      var userRef = db.collection("users");
      userRef
        .doc(item?.uid)
        .set(
          {
            onboard: e,
          },
          { merge: true }
        )
        .then((res) => {
          this.load("data");
        });
    },
    changeCommission(item, e) {
      var db = firebase.firestore();
      var userRef = db.collection("users");
      userRef
        .doc(item?.uid)
        .set(
          {
            commission: e,
          },
          { merge: true }
        )
        .then((res) => {
          this.load("data");
        });
    },
    csv_export() {
      let csvContent = "";

      var universalBOM = "\uFEFF";

      this.fields.forEach(function (row) {
        csvContent += row.label + ",";
      });
      csvContent += "\r\n";
      this.items.forEach(function (row) {
        var row_str = "";
        row_str += '"' + row.phoneNumber + '",';
        row_str += '"' + row.countryNameCode + ' ",';
        row_str += '"' + row.amountSumGave + '",';
        row_str += '"' + row.amountSumGot + '",';
        row_str += '"' + row.cashSumGave + '",';
        row_str += '"' + row.cashSumGot + '",';
        row_str += '"' + row.businessCount + '",';
        row_str += '"' + row.createdAt + '",';
        row_str += '"' + row.uid + '",';

        csvContent += row_str + "\r\n";
      });
      var universalBOM = "\uFEFF";
      var a = window.document.createElement("a");
      a.setAttribute(
        "href",
        "data:text/csv; charset=utf-8," +
          encodeURIComponent(universalBOM + csvContent)
      );
      a.setAttribute("download", "users" + this.need_refresh + ".csv");
      window.document.body.appendChild(a);
      a.click();
    },
    // Delete Onboard stripe on button click added by SST Team
    deleteAccount(accountId, uid) {
      axios
        .post(
          'http://143.110.184.138:7778/deleteAccount',
          // "http://67.205.148.222:7778/deleteAccount",
          // "http://localhost:7778/deleteAccount",
          {
            stripeAccountId: accountId,
            uid: uid,
          },
          { "Content-Type": "application/json" }
        )
        .then((res) => {
          this.load("data");
        });
    },
  },
};
</script>

<style scoped>
.stripe-details-box {
  align-items: center;
  display: flex;
  justify-content: center;
}
</style>